// Shared constants to avoid hoisting issues
export const emptySet = new Set();
export const emptyMap = new Map();
export const noop = () => {};
